import { t } from 'i18next'
import EnhancedTable from 'src/components/shared/EnhancedTable/EnhancedTable'
import ButtonSecondary from 'src/components/shared/ui/ButtonSecondary'
import LexnetDialog from 'src/components/shared/ui/LexnetDialog'
import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import {
  Interviniente,
  RepresentanteLegal,
  RepresentanteProcesal
} from 'src/interfaces/EscritosLegales'
import { tipoRepresentacionProfesional } from '../RepresentanteProcesal/types'
import { checkTipoPersonaFisica } from '../types'

type Props = {
  openDialog: boolean
  interviniente: Interviniente | null
  close: () => void
}

export default function RepresentantesDialog(props: Props): JSX.Element {
  const { openDialog, interviniente, close } = props
  return (
    <>
      <LexnetDialog
        isOpen={openDialog}
        close={() => close()}
        title={t('form.dialog.title.representacion')}
        buttons={<ButtonSecondary onClick={() => close()}>{t('actions.close')}</ButtonSecondary>}
      >
        {interviniente?.representantesLegales && interviniente?.representantesLegales.length > 0 && (
          <FieldsetGroup legend={t('form.legend.representantes_legales')}>
            <EnhancedTable
              variation="form"
              columns={[
                {
                  Header: 'Representante Legal',
                  accessor: (representante: RepresentanteLegal) => {
                    return representante &&
                      representante.personaTipo &&
                      checkTipoPersonaFisica(representante.personaTipo)
                      ? representante.nombre
                      : `${representante.primerApellido}, ${representante.nombre}`
                  }
                },
                {
                  Header: 'Nº de identificación',
                  accessor: 'identificacion'
                }
              ]}
              data={(interviniente && interviniente.representantesLegales) || []}
              toolbar={false}
              noRegistersMessage={t('components.enhanced_table.no_registers.intervinientes')}
            />
          </FieldsetGroup>
        )}

        {interviniente?.representantesProcesales &&
          interviniente?.representantesProcesales.length > 0 && (
            <FieldsetGroup legend={t('form.legend.representantes_procesales')}>
              <EnhancedTable
                variation="form"
                columns={[
                  {
                    Header: 'Tipo de representación',
                    accessor: 'representacionTipo.descripcion'
                  },
                  {
                    Header: 'Representante',
                    accessor: (item: RepresentanteProcesal) =>
                      item.representacionTipo &&
                      !tipoRepresentacionProfesional(item.representacionTipo)
                        ? item.entidad?.descripcion
                        : `${item.nombre} ${item.primerApellido}`
                  },
                  {
                    Header: 'Nº de colegiado',
                    accessor: (item: RepresentanteProcesal) =>
                      item.representacionTipo &&
                      !tipoRepresentacionProfesional(item.representacionTipo)
                        ? item.entidad?.codigo
                        : item.codigoColegiado
                  }
                ]}
                data={(interviniente && interviniente.representantesProcesales) || []}
                toolbar={false}
                noRegistersMessage={t('components.enhanced_table.no_registers.intervinientes')}
              />
            </FieldsetGroup>
          )}
      </LexnetDialog>
    </>
  )
}
